import { Component, OnInit ,Input, EventEmitter, Output } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-report-load',
  template: `<a class="pepi-gray" href="javascript:void(0)" (click) = "onClicked()">{{reportName}}</a>`,
  styleUrls: ['./table-report-load.component.scss']
})
export class TableReportLoadComponent implements ViewCell, OnInit {

  @Input() value : string | number;
  @Input() rowData : any;
  reportName  = '';
  flag = true;
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output () editPopUp: EventEmitter<boolean> = new EventEmitter();
  ngOnInit() {
    // this.reportName = this.rowData.report_name
  	this.reportName =  (this.rowData["label"] !==undefined) ? this.rowData.label : this.rowData.report_name ;
  }
  onClicked(){
    this.editPopUp.emit(this.flag)
  	this.clicked.emit(this.rowData);
  }

}
